import { ref } from 'vue';
import { loadStripe } from '@stripe/stripe-js';
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.component('stripe', Component);

    const ready = ref(false);
    const active = ref(true);
    const error = ref(null);
    const valid = ref(false);
    const cardObject = ref();
    const stripeObject = ref(null); // <---- ΧΡΕΙΑΖΟΤΑΝ ΚΑΙ ΑΥΤΟ!

    const load = () => {
      let elements;

      loadStripe(options.publicKey)
        .then((response) => {
          stripeObject.value = response; // <---- ΓΙΑ ΝΑ ΤΟ ΠΑΡΩ ΣΤΟ PARENT!
          elements = stripeObject.value.elements();

          cardObject.value = elements.create("card", {
            hideIcon: true,
            hidePostalCode: true,
            style: {
              base: {
                iconColor: '#000',
                color: '#000',
                fontWeight: '500',
                fontFamily: 'new-hero, sans-serif',
                fontSize: '16px',
                textTransform: 'uppercase',
                fontSmoothing: 'antialiased',
                ':-webkit-autofill': {
                  color: '#000',
                },
                '::placeholder': {
                  color: "#000",
                },
              },
              invalid: {
                iconColor: '#ce0000',
                color: '#ce0000',
              },
            },
          });

          cardObject.value.addEventListener("change", function (e) {
            valid.value = e.complete;
            error.value = e.error || null;
          });

          setTimeout(() => {
            ready.value = true;
          }, 2000);
        })
        .catch((error) => {
          console.log('Stripe initialization failed:', error.message);
          ready.value = false;
        });
    }

    const show = () => { active.value = true; }
    const hide = () => { active.value = false; }

    load();

    const stripe = { ready, active, error, valid, show, hide, cardObject, stripeObject }; // <--- expose!
    app.config.globalProperties.$stripe = stripe;
    app.provide('$stripe', stripe);
  }
}
